
import {createStore} from 'vuex';



import { account } from './modules/account.module.js';
import { activities } from './modules/activities.module.js';
import { collegiats } from './modules/collegiats.module';
import { courses } from './modules/courses.module.js';
import { checkout } from './modules/checkout.module.js';
import { professionals } from './modules/professionals.module.js';

export var store = createStore({
	modules: {
		account,
		activities,
		collegiats,
		courses,
		checkout,
		professionals
	}
})